import { useEffect, useState } from 'react';

const usePropChangeDelay = <T>(prop: T, delay: number) => {
	const [state, setState] = useState(prop);

	useEffect(() => {
		let timer: NodeJS.Timeout;
		if (!prop) {
			timer = setTimeout(() => setState(prop), delay);
		} else {
			setState(prop);
		}

		return () => clearTimeout(timer);
	}, [prop, delay]);
	return state;
};

export default usePropChangeDelay;
